import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { GoogleMap, useJsApiLoader } from "@react-google-maps/api";
import FeatherIcon from "../ui/feather-icon/FeatherIcon";
import SpinnerApple from "../ui/spinner/Spinner.Apple";
import { FormContext } from 'noood/contexts/contexts';
import { form_validator } from "../form/FormFieldValidator";
import PropTypes from "prop-types";
import * as stylex from '@stylexjs/stylex';
import Icon from "noood/comp/ui/feather-icon/Icon";
import FlexVertical from "noood/comp/ui/containers/flex-boxes/FlexVertical";
import Row from "noood/comp/ui/containers/flex-boxes/Row";
import Text from "noood/comp/text/Text";
export default function LocationSearch(props) {
  var _props$validations, _form_$formObj2, _props$map_info;
  var _useJsApiLoader = useJsApiLoader({
      id: 'google-maps-script',
      libraries: ['places'],
      googleMapsApiKey: process.env.__MAPS_API_KEY
    }),
    isLoaded = _useJsApiLoader.isLoaded,
    loadError = _useJsApiLoader.loadError;
  var form_ = useContext(FormContext);
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    val = _useState2[0],
    set_val = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    predictions = _useState4[0],
    set_predictions = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    xhr_timeout = _useState6[0],
    set_xhr_timeout = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    autocomplete_service = _useState8[0],
    set_autocomplete_service = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    picked = _useState0[0],
    set_picked = _useState0[1];
  var _useState1 = useState(null),
    _useState10 = _slicedToArray(_useState1, 2),
    autocomplete_session = _useState10[0],
    set_autocomplete_session = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    highlighted_prediction = _useState12[0],
    set_highlighted_prediction = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    predicting = _useState14[0],
    set_predicting = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    click_selection = _useState16[0],
    set_click_selection = _useState16[1];
  var _useState17 = useState(null),
    _useState18 = _slicedToArray(_useState17, 2),
    chosen_prediction = _useState18[0],
    set_chosen_prediction = _useState18[1];
  var _useState19 = useState({
      lat: 14.5995,
      lng: 120.9842
    }),
    _useState20 = _slicedToArray(_useState19, 2),
    center = _useState20[0],
    set_center = _useState20[1];
  var _useState21 = useState(null),
    _useState22 = _slicedToArray(_useState21, 2),
    map = _useState22[0],
    set_map = _useState22[1];
  var _useState23 = useState(null),
    _useState24 = _slicedToArray(_useState23, 2),
    place_id = _useState24[0],
    set_place_id = _useState24[1];
  var _useState25 = useState(false),
    _useState26 = _slicedToArray(_useState25, 2),
    focused = _useState26[0],
    setFocused = _useState26[1];
  useEffect(function () {
    if (isLoaded) {
      set_autocomplete_service(new google.maps.places.AutocompleteService());
      set_autocomplete_session(new google.maps.places.AutocompleteSessionToken());
    }
  }, [isLoaded]);

  // search google api
  useEffect(function () {
    if (click_selection) {} else {
      set_picked(false);
      if (xhr_timeout != null) {
        clearTimeout(xhr_timeout);
      }
      if ((val === null || val === void 0 ? void 0 : val.trim().length) > 0) {
        set_predicting(true);
        form_ === null || form_ === void 0 || form_.__collect(props.name, val, form_validator.validate(props.validations, val));
      } else {
        set_predictions([]);
        set_predicting(false);
      }
      set_xhr_timeout(setTimeout(function () {
        if ((val === null || val === void 0 ? void 0 : val.trim().length) > 0) {
          autocomplete_service.getPlacePredictions({
            input: val,
            sessionToken: autocomplete_session,
            bounds: new google.maps.LatLngBounds(new google.maps.LatLng(12.8797, 121.7740))
          }).then(function (response) {
            // console.log("predictions length: ", response.predictions.length)
            set_predictions(response.predictions);
            set_highlighted_prediction(0);
            set_predicting(false);
          });
        }
      }, 500));
    }
  }, [val]);
  useEffect(function () {
    if (chosen_prediction) {
      var _google$maps$Geocoder, _form_$__merge, _form_$__collect;
      set_click_selection(true);
      set_val(chosen_prediction.structured_formatting.main_text);
      var partial_obj = {};
      (_google$maps$Geocoder = new google.maps.Geocoder()) === null || _google$maps$Geocoder === void 0 || (_google$maps$Geocoder = _google$maps$Geocoder.geocode({
        placeId: chosen_prediction.place_id
      })) === null || _google$maps$Geocoder === void 0 || _google$maps$Geocoder.then(function (result) {
        var _result$results;
        var finalResult = (_result$results = result.results) === null || _result$results === void 0 ? void 0 : _result$results[0];
        if (finalResult) {
          partial_obj.lat = finalResult.geometry.location.lat();
          partial_obj.lng = finalResult.geometry.location.lng();
        }
      });
      partial_obj = _objectSpread(_objectSpread({}, partial_obj), {}, {
        place_id: chosen_prediction.place_id,
        ref: chosen_prediction.reference,
        address: chosen_prediction.structured_formatting.secondary_text,
        location: chosen_prediction.structured_formatting.main_text
      });
      form_ === null || form_ === void 0 || (_form_$__merge = form_.__merge) === null || _form_$__merge === void 0 || _form_$__merge.call(form_, partial_obj);
      set_place_id(chosen_prediction.place_id);
      form_ === null || form_ === void 0 || (_form_$__collect = form_.__collect) === null || _form_$__collect === void 0 || _form_$__collect.call(form_, props.name, partial_obj, []);
    } else {
      // form_?.__delete?.(props.name)
      // form_?.__delete?.("maps_meta")
    }
  }, [chosen_prediction]);
  useEffect(function () {
    // set_chosen_prediction(props.prediction)
    if (props.prediction && isLoaded && map) {
      var _props$prediction;
      set_click_selection(true);
      set_place_id((_props$prediction = props.prediction) === null || _props$prediction === void 0 ? void 0 : _props$prediction.place_id);
    }
  }, [props.prediction, isLoaded, map]);
  var __highlight_prediction = function __highlight_prediction(is_down) {
    var current_highlight = highlighted_prediction;
    if (is_down) {
      if (current_highlight < predictions.length - 1) {
        set_highlighted_prediction(++current_highlight);
      } else set_highlighted_prediction(0);
    } else {
      if (current_highlight === 0) {
        set_highlighted_prediction(predictions.length - 1);
      } else set_highlighted_prediction(--current_highlight);
    }
  };
  var onUnmount = useCallback(function callback(map) {
    set_map(null);
  }, []);
  useEffect(function () {
    if (place_id) {
      var geoc = new google.maps.Geocoder();
      geoc.geocode({
        placeId: place_id
      }).then(function (res) {
        var _res$results;
        var place = res === null || res === void 0 || (_res$results = res.results) === null || _res$results === void 0 ? void 0 : _res$results[0];
        if (place) {
          var _form_$formObj;
          console.log('place', place);
          map.setCenter(place.geometry.location);
          map.setZoom(18);
          var marker = new google.maps.Marker({
            position: place.geometry.location
          });
          marker.setMap(map);
          var new_map_data_obj = _objectSpread(_objectSpread({}, form_ === null || form_ === void 0 || (_form_$formObj = form_.formObj) === null || _form_$formObj === void 0 ? void 0 : _form_$formObj[props.name]), {}, {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
          });
          form_ === null || form_ === void 0 || form_.__collect(props.name, new_map_data_obj, []);
          set_val(place.formatted_address);
        }
      });
    }
  }, [place_id]);
  var isRequired = ((_props$validations = props.validations) === null || _props$validations === void 0 ? void 0 : _props$validations.indexOf('required')) > -1;
  if (isLoaded === void 0 || isLoaded === null) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  return /*#__PURE__*/React.createElement("div", stylex.props(ui.base), props.label && /*#__PURE__*/React.createElement("span", {
    className: "text-label"
  }, props.label), /*#__PURE__*/React.createElement("div", _extends({}, stylex.props(ui.thisField, focused && ui.focused, isRequired && ui.required, isRequired && ui.required_border), {
    style: {
      borderBottomLeftRadius: (predictions === null || predictions === void 0 ? void 0 : predictions.length) > 0 ? '0' : 'var(--roundness)',
      borderBottomRightRadius: (predictions === null || predictions === void 0 ? void 0 : predictions.length) > 0 ? '0' : 'var(--roundness)'
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      width: '20px',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: 'map-pin',
    color: isRequired ? 'var(--text-on-required)' : 'var(--text-color)'
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      border: '0',
      marginLeft: '5px',
      width: '100%',
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement("input", _extends({
    style: {
      padding: '0',
      fontSize: '14px',
      backgroundColor: "transparent",
      fontFamily: "font1"
    }
  }, stylex.props(ui.input, isRequired && ui.required_input), {
    value: form_ === null || form_ === void 0 || (_form_$formObj2 = form_.formObj) === null || _form_$formObj2 === void 0 || (_form_$formObj2 = _form_$formObj2[props.name]) === null || _form_$formObj2 === void 0 ? void 0 : _form_$formObj2.location,
    onChange: function onChange(e) {
      var _e$target$value;
      set_click_selection(false);
      form_ === null || form_ === void 0 || form_.__collect(props.name, e.target.value, form_validator.validate(props.validations, (_e$target$value = e.target.value) === null || _e$target$value === void 0 ? void 0 : _e$target$value.trim()));
      set_val(e.target.value);
    },
    onFocus: function onFocus() {
      return setFocused(true);
    },
    onBlur: function onBlur() {
      return setFocused(false);
    },
    onKeyDown: function onKeyDown(e) {
      if (e.keyCode === 13 && (predictions === null || predictions === void 0 ? void 0 : predictions.length) > 0) {
        var _predictions$highligh;
        e.preventDefault();
        set_val((_predictions$highligh = predictions[highlighted_prediction]) === null || _predictions$highligh === void 0 ? void 0 : _predictions$highligh.structured_formatting.main_text);
        set_predictions([]);
        set_picked(false);
        set_click_selection(true);
        set_chosen_prediction(predictions[highlighted_prediction]);
      }
    },
    onKeyUp: function onKeyUp(e) {
      e.preventDefault();
      if (e.key === 'ArrowDown') {
        __highlight_prediction(true);
      } else if (e.key === 'ArrowUp') {
        __highlight_prediction(false);
      } else if (e.key === 'Escape') {
        set_predictions([]);
        set_picked(false);
        set_highlighted_prediction(null);
      }
    }
  }, props))), /*#__PURE__*/React.createElement("div", {
    style: {
      border: '0',
      width: '20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, predicting ? /*#__PURE__*/React.createElement(SpinnerApple, null) : null)), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      zIndex: '1'
    }
  }, (predictions === null || predictions === void 0 ? void 0 : predictions.length) > 0 && !picked ? /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      zIndex: 1,
      display: 'block',
      width: '100%',
      backgroundColor: "var(--shade)"
    }
  }, /*#__PURE__*/React.createElement("ol", {
    className: "LocationSearch__ui.prediction_list eve8uvvx ev1ghz6dp ev1717udv eve0pwq ev19ypqd9 ev1nge6hi evs1s249 ev32b0ac evf6xtqy ev11ycvst"
  }, predictions.map(function (prediction, idx) {
    var _prediction$types, _prediction$structure;
    var classNames = [];
    if (idx === highlighted_prediction) {
      classNames.push('ui-map-prediction-highlighted');
    }
    var icon = 'map-pin';
    if (((_prediction$types = prediction.types) === null || _prediction$types === void 0 ? void 0 : _prediction$types.indexOf('lodging')) > 0) {
      icon = 'home';
    }
    return /*#__PURE__*/React.createElement("li", _extends({
      key: idx,
      onClick: function onClick() {
        set_predictions([]);
        set_picked(true);
        set_click_selection(true);
        set_chosen_prediction(prediction);
      }
    }, {
      className: "LocationSearch__ui.prediction_list_item ev1ypdohk ev1m3phxg ev1dfczft evso031l ev1q0q8m5 ev19lntrs ev14odnwx"
    }), /*#__PURE__*/React.createElement(Row, {
      verticalAlign: "top",
      gap: 10
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FeatherIcon, {
      icon: icon
    })), /*#__PURE__*/React.createElement(FlexVertical, {
      gap: 0
    }, /*#__PURE__*/React.createElement(Text, {
      size: 13
    }, prediction.structured_formatting.main_text), ((_prediction$structure = prediction.structured_formatting) === null || _prediction$structure === void 0 ? void 0 : _prediction$structure.secondary_text) && /*#__PURE__*/React.createElement(Text, {
      secondary: true,
      size: 11
    }, prediction.structured_formatting.secondary_text))));
  }))) : null, chosen_prediction && /*#__PURE__*/React.createElement(Text, {
    secondary: true,
    size: 13
  }, chosen_prediction.structured_formatting.secondary_text), !chosen_prediction && ((_props$map_info = props.map_info) === null || _props$map_info === void 0 ? void 0 : _props$map_info.address) && /*#__PURE__*/React.createElement(Text, {
    secondary: true,
    size: 14
  }, props.map_info.address), isLoaded ? /*#__PURE__*/React.createElement(GoogleMap, {
    mapContainerStyle: {
      marginTop: '5px',
      borderRadius: '5px',
      width: '100%',
      height: '200px',
      border: "2px solid var(--shade-40)"
    },
    options: {
      disableDefaultUI: true
    },
    center: center,
    zoom: 15,
    onLoad: function onLoad(map) {
      var _props$map_info2, _props$map_info3, _props$map_info4;
      map.setOptions({
        gestureHandling: 'cooperative',
        minZoom: 17,
        maxZoom: 20
      });
      set_map(map);
      if ((_props$map_info2 = props.map_info) !== null && _props$map_info2 !== void 0 && _props$map_info2.lat && (_props$map_info3 = props.map_info) !== null && _props$map_info3 !== void 0 && _props$map_info3.lng) {
        var lat_lng = {
          lat: Number(props.map_info.lat),
          lng: Number(props.map_info.lng)
        };
        map.setCenter(lat_lng);
        map.setZoom(19);
        var marker = new google.maps.Marker({
          position: new google.maps.LatLng(lat_lng),
          map: map
        });
        marker.setMap(map);
      } else if ((_props$map_info4 = props.map_info) !== null && _props$map_info4 !== void 0 && _props$map_info4.place_id) {
        var _google$maps$Geocoder2;
        (_google$maps$Geocoder2 = new google.maps.Geocoder()) === null || _google$maps$Geocoder2 === void 0 || (_google$maps$Geocoder2 = _google$maps$Geocoder2.geocode({
          placeId: props.map_info.place_id
        })) === null || _google$maps$Geocoder2 === void 0 || _google$maps$Geocoder2.then(function (result) {
          var place = result.results[0];
          console.log("place: ", place);
          map.setCenter(place.geometry.location);
          map.setZoom(19);
          var marker = new google.maps.Marker({
            position: place.geometry.location
          });
          marker.setMap(map);
          set_map(map);
          set_center(place.geometry.location);
        });
      }
    },
    onUnmount: onUnmount
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, isLoaded === null ? 'null' : /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      padding: '5px',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: 'var(--roundness)',
      backgroundColor: '#e0c3c3'
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FeatherIcon, {
    icon: 'warning'
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: "text-negative"
  }, "Loading map data..."))))));
}
LocationSearch.propTypes = {
  map_info: PropTypes.shape({
    lat: PropTypes.string,
    lng: PropTypes.string,
    address: PropTypes.string,
    place_id: PropTypes.string,
    reference: PropTypes.string
  }),
  prediction: PropTypes.shape({
    structured_formatting: PropTypes.shape({
      main_text: PropTypes.string,
      secondary_text: PropTypes.string
    }),
    place_id: PropTypes.string,
    reference: PropTypes.string,
    geo_loc: PropTypes.string
  })
};

// @ts-ignore
_inject(".ev1y7ric0{background-color:var(--shade-05)}", 3000);
_inject(".evmkeg23{border-width:1px}", 2000);
_inject(".ev1y0btm7{border-style:solid}", 2000);
_inject(".evsqfd0d{border-color:var(--shade-20)}", 2000);
_inject(".ev78zum5{display:flex}", 3000);
_inject(".evxwrc4x{border-radius:var(--roundness)}", 2000);
_inject(".ev14odnwx{padding:5px}", 1000);
_inject(".ev1qjc9v5{align-items:stretch}", 3000);
_inject(".ev1tgzv6z{height:var(--field-height)}", 4000);
_inject(".ev8vmwtk{box-shadow:0 0 0 3px rgba(175,198,255,.51)}", 3000);
_inject(".ev1jqyx15{transition:box-shadow .1s}", 2000);
_inject(".evc5895u{border-color:var(--shade-30)}", 2000);
_inject(".ev1a2a7pz{outline:none}", 2000);
_inject(".evc342km{border-width:0}", 2000);
_inject(".evha96y3{border-style:dotted}", 2000);
_inject(".ev71xlcl{border-color:red}", 2000);
_inject(".evh8yej3{width:100%}", 4000);
_inject(".ev17e5z5g{color:var(--text-color)}", 3000);
_inject(".ev1lko15j{background-color:var(--shade-required)}", 3000);
_inject(".ev1kijww5{border-color:var(--shade-required-border)}", 2000);
_inject(".eve8uvvx{list-style:none}", 2000);
_inject(".ev1ghz6dp{margin:0}", 1000);
_inject(".ev1717udv{padding:0}", 1000);
_inject(".eve0pwq{border-left-width:1px}", 4000);
_inject(".ev19ypqd9{border-left-style:solid}", 4000);
_inject(".ev1nge6hi{border-left-color:var(--shade-15)}", 4000);
_inject(".evs1s249{border-right-width:1px}", 4000);
_inject(".ev32b0ac{border-right-style:solid}", 4000);
_inject(".evf6xtqy{border-right-color:var(--shade-15)}", 4000);
_inject(".ev11ycvst{background-color:var(--shade)}", 3000);
_inject(".ev1ypdohk{cursor:pointer}", 3000);
_inject(".ev1m3phxg{transition:background-color .1s}", 2000);
_inject(".ev1dfczft:hover{background-color:var(--shade-05)}", 3130);
_inject(".evso031l{border-bottom-width:1px}", 4000);
_inject(".ev1q0q8m5{border-bottom-style:solid}", 4000);
_inject(".ev19lntrs{border-bottom-color:var(--shade-10)}", 4000);
_inject(".evip966{color:var(--text-on-required)}", 3000);
var ui = {
  thisField: {
    "LocationSearch__ui.thisField": "LocationSearch__ui.thisField",
    backgroundColor: "ev1y7ric0",
    borderWidth: "evmkeg23",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "ev1y0btm7",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "evsqfd0d",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    display: "ev78zum5",
    borderRadius: "evxwrc4x",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    padding: "ev14odnwx",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    alignItems: "ev1qjc9v5",
    height: "ev1tgzv6z",
    $$css: true
  },
  focused: {
    "LocationSearch__ui.focused": "LocationSearch__ui.focused",
    boxShadow: "ev8vmwtk",
    transition: "ev1jqyx15",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    borderWidth: "evmkeg23",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "ev1y0btm7",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "evc5895u",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    $$css: true
  },
  input: {
    "LocationSearch__ui.input": "LocationSearch__ui.input",
    outline: "ev1a2a7pz",
    outlineColor: null,
    outlineOffset: null,
    outlineStyle: null,
    outlineWidth: null,
    borderWidth: "evc342km",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "evha96y3",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "ev71xlcl",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    width: "evh8yej3",
    color: "ev17e5z5g",
    $$css: true
  },
  required: {
    "LocationSearch__ui.required": "LocationSearch__ui.required",
    backgroundColor: "ev1lko15j",
    $$css: true
  },
  required_border: {
    "LocationSearch__ui.required_border": "LocationSearch__ui.required_border",
    borderColor: "ev1kijww5",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    $$css: true
  },
  required_input: {
    "LocationSearch__ui.required_input": "LocationSearch__ui.required_input",
    color: "evip966",
    $$css: true
  }
};